import React from 'react';
import { useLocale } from '../contexts/LocaleContext';

const DemoBanner: React.FC = () => {
  const { t } = useLocale();

  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-tertiary text-white rounded-2xl px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <div className="text-lg font-semibold heading-font">{t.promo.heading}</div>
          </div>

          <div className="flex-shrink-0">
            <button
              className="bg-primary-gradient1 text-white px-4 py-2 rounded-full font-semibold hover:opacity-90 transition-colors"
              onClick={() => {
                // default action: scroll to contact form
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
                else window.location.hash = '#contact';
              }}
            >
              {t.promo.cta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoBanner;
